import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import type { RootState } from "../redux/store";
import useAxios from "../hooks/useAxios";
import { IDashboard, ChartData, TopWeeklyItem } from "../types/interfaces";
import MonthlyOrderChart from "./dasboard-partial/MonthlyOrderChart";
import TopSellingWeeklyChart from "./dasboard-partial/TopSellingWeeklyChart";

function Dashboard() {
  const axiosInstance = useAxios();
  const user = useSelector((state: RootState) => state.user.user);

  const [dashboarddata, setDashboardData] = useState<IDashboard>({
    product_count: 0,
    order_count: 0,
    complaint_count: 0,
    customer_count: 0,
  });
  const [monthlychartdata, setMonthlyChartData] = useState<ChartData[]>([]);
  const [weeklychartdata, setWeeklyChartData] = useState<TopWeeklyItem[]>([]);

  useEffect(() => {
    getDashboardData();
  }, []);

  const getDashboardData = async () => {
    try {
      const response: any = await axiosInstance({
        url: "dashboard/dashboard-data",
        method: "GET",
      });

      setDashboardData({
        product_count: response.data.product_count,
        order_count: response.data.order_count,
        complaint_count: response.data.complaint_count,
        customer_count: response.data.customer_count,
      });

      setMonthlyChartData(response.data.monthly_order);
      setWeeklyChartData(response.data.weekly_top_products);
    } catch (error) {
      console.error("Dashboard API error:", error);
    }
  };

  return (
    <div id="kt_content" className="content flex-column-fluid">
	{user.role_id === 4 && (
		<div className="row gx-5 gx-xl-0 mb-5">
			<div
			  className="card border-transparent"
			  data-bs-theme="light"
			  style={{ backgroundColor: "#FF9933", height: "105px" }}
			>
			  <div className="card-body d-flex ps-xl-15">
				<div className="m-0">
				  <div className="position-relative fs-2x z-index-2 fw-bold text-white mb-0">
					<span className="me-1">Welcome, {user?.fullname}</span>
				  </div>
				</div>
				<img
				  src="/assets/media/illustrations/17-dark.png"
				  className="position-absolute me-3 bottom-0 end-0 h-100px"
				  alt=""
				/>
			  </div>
			</div>
			<img
			  src="/assets/media/illustrations/14-dark.png"
			  className="h-300px"
			  alt=""
			/>
		</div>
	  )}
	  {(user.role_id === 0 || user.role_id === 1) && (
      <div className="row gx-5 gx-xl-10">
        {/*Main content area start*/}
        <div className="col-xl-12">
          {/*Tabs content area start*/}
          <div className="row gx-5 gx-xl-10">
            <div className="col-xl-12 mb-10">
              <div className="card card-flush h-xl-100">
                <div className="card-body">
                  <div className="">
                    <div className="row g-3 g-lg-6 mb-5">
                      <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                        <div className="bg-gray-100 bg-opacity-70 rounded-2 px-6 py-5">
                          <div className="symbol symbol-30px me-5 mb-8">
                            <span className="symbol-label">
                              <i className="ki-duotone ki-element-plus fs-3x text-primary">
								 <span className="path1"></span>
								 <span className="path2"></span>
								 <span className="path3"></span>
								 <span className="path4"></span>
								 <span className="path5"></span>
								</i>
                            </span>
                          </div>
                          <div className="m-0">
                            <span className="text-gray-700 fw-bolder d-block fs-2qx lh-1 ls-n1 mb-1">
                              {dashboarddata.product_count}
                            </span>
                            <span className="text-gray-500 fw-semibold fs-6">
                              Total Products
                            </span>
                          </div>
                        </div>
                      </div>
					  <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                        <div className="bg-gray-100 bg-opacity-70 rounded-2 px-6 py-5">
                          <div className="symbol symbol-30px me-5 mb-8">
                            <span className="symbol-label">
                              <i className="ki-duotone ki-handcart fs-3x text-primary">
                              </i>
                            </span>
                          </div>
                          <div className="m-0">
                            <span className="text-gray-700 fw-bolder d-block fs-2qx lh-1 ls-n1 mb-1">
                              {dashboarddata.order_count}
                            </span>
                            <span className="text-gray-500 fw-semibold fs-6">
                              Total Orders{" "}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                        <div className="bg-gray-100 bg-opacity-70 rounded-2 px-6 py-5">
                          <div className="symbol symbol-30px me-5 mb-8">
                            <span className="symbol-label">
                              <i className="ki-duotone ki-directbox-default fs-3x text-primary">
								 <span className="path1"></span>
								 <span className="path2"></span>
								 <span className="path3"></span>
								 <span className="path4"></span>
								</i>
                            </span>
                          </div>
                          <div className="m-0">
                            <span className="text-gray-700 fw-bolder d-block fs-2qx lh-1 ls-n1 mb-1">
							{dashboarddata.complaint_count}
                            </span>
                            <span className="text-gray-500 fw-semibold fs-6">
                              Complaints & Issue
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                        <div className="bg-gray-100 bg-opacity-70 rounded-2 px-6 py-5">
                          <div className="symbol symbol-30px me-5 mb-8">
                            <span className="symbol-label">
                              <i className="ki-duotone ki-people fs-3x text-primary">
                                <span className="path1"></span>
                                <span className="path2"></span>
                                <span className="path3"></span>
                                <span className="path4"></span>
                                <span className="path5"></span>
                              </i>
                            </span>
                          </div>
                          <div className="m-0">
                            <span className="text-gray-700 fw-bolder d-block fs-2qx lh-1 ls-n1 mb-1">
                              {dashboarddata.customer_count}
                            </span>
                            <span className="text-gray-500 fw-semibold fs-6">
                              Customers
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/*Tabs content area end*/}
          {/*Chart content area start*/}
		  <div className="row g-5 g-xl-10">
            <div className="col-xl-12">
              <div className="card card-flush h-xl-100">
                <div className="card-header pt-7">
                  <h3 className="card-title align-items-start flex-column">
                    <span className="card-label fw-bold text-gray-800">
                      Orders Statastic
                    </span>
                    <span className="text-gray-500 mt-1 fw-semibold fs-6">
                      Monthly Orders - Current Year
                    </span>
                  </h3>
                </div>
                <div className="card-body d-flex align-items-end px-0 pt-3 pb-5">
                  <div
                    id=""
                    className="h-325px w-100 min-h-auto ps-4 pe-6"
                    style={{ minHeight: "340px" }}
                  >
                    <MonthlyOrderChart chartData={monthlychartdata} />
                  </div>
                </div>
              </div>
            </div>
		  </div>
          {/*Chart content area end*/}
		  {/*Chart content area start*/}
		  <div className="row g-5 g-xl-10 mt-5">
            <div className="col-xl-12">
              <div className="card card-flush h-xl-100">
                <div className="card-header pt-7">
                  <h3 className="card-title align-items-start flex-column">
                    <span className="card-label fw-bold text-gray-800">
                      Top Selling
                    </span>
					<span className="text-gray-500 mt-1 fw-semibold fs-6">
                      Weekly Orders - Products
                    </span>
                  </h3>
                </div>
                <div className="card-body d-flex align-items-end px-0 pt-3 pb-5">
                  <div
                    id=""
                    className="h-325px w-100 min-h-auto ps-4 pe-6"
                    style={{ minHeight: "340px" }}
                  >
                    <TopSellingWeeklyChart chartData={weeklychartdata} />
                  </div>
                </div>
              </div>
            </div>
		  </div>
          {/*Chart content area end*/}
        </div>
        {/*Main content area end*/}
        {/*Notification content area start*/}
			{/*<div className="col-xl-3">
          <div className="card card-flush h-xl-100">
            <div className="card-header pt-7">
              <h3 className="card-title align-items-start flex-column">
                <span className="card-label fw-bold text-gray-900">
                  Notifications
                </span>
              </h3>
            </div>
            <div className="card-body">
              <div
                className="hover-scroll-overlay-y pe-6 me-n6"
                style={{ height: "415px" }}
              >
                
              </div>
            </div>
          </div>
			</div>*/}
        {/*Notification content area end*/}
      </div>
	  )}
    </div>
  );
}

export default Dashboard;
